import { isDevelopmentMode } from 'src/utils/helpers';

export default function useDevelopmentMode() {
  const isDev = isDevelopmentMode();
  return isDev;
}
